export default {
  // Page titles
  customerCenter: 'Customer Center',
  rolePermissionManagement: 'Role Permission Management',

  // Search and filter
  searchPlaceholder: 'Please enter role code, name or description',
  statusFilter: 'Status Filter',
  statusAll: 'All',
  statusEnabled: 'Enabled',
  statusDisabled: 'Disabled',
  search: 'Search',
  searchCompleted: 'Search completed',

  // Action buttons
  addRole: 'Add Role',
  editRole: 'Edit Role',
  edit: 'Edit',
  delete: 'Delete',
  more: 'More',
  permissionSetting: 'Permission Setting',
  customerConfig: 'Customer Config',

  // Table columns
  roleCode: 'Role Code',
  roleName: 'Role Name',
  description: 'Description',
  attribute: 'Attribute',
  status: 'Status',
  actions: 'Actions',

  // Form fields
  roleCodePlaceholder: 'Please enter role code',
  roleNamePlaceholder: 'Please enter role name',
  attributePlaceholder: 'Please select attribute',
  descriptionPlaceholder: 'Please enter role description',

  // Attribute options
  attributeCustomer: 'Customer',
  attributeSupplier: 'Supplier',

  // Validation messages
  roleCodeRequired: 'Please enter role code',
  roleNameRequired: 'Please enter role name',
  attributeRequired: 'Please select attribute',

  // Confirmation dialogs
  confirmDelete: 'Confirm Delete',
  confirmDeleteContent: 'Are you sure to delete role "{roleName}"? This action cannot be undone.',

  // Operation result messages
  addSuccess: 'Added successfully',
  editSuccess: 'Edited successfully',
  deleteSuccess: 'Deleted successfully',
  statusChangeSuccess: '{roleName} status has been {status}',

  // Common
  loading: 'Loading...',
  loadDataFailed: 'Failed to load data',
  save: 'Save',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Role customer configuration page
  availableCompanies: 'Available Companies',
  authorizedCompanies: 'Authorized Companies',
  searchCompanyPlaceholder: 'Search company name',
  authorize: 'Authorize',
  unauthorize: 'Unauthorize',
  selectCompaniesToAuthorize: 'Please select companies to authorize first',
  selectCompaniesToUnauthorize: 'Please select companies to unauthorize first',
  companySaveSuccess: 'Company configuration saved successfully',
  companySaveFailed: 'Save failed, please try again',

  // Role permission configuration page
  availablePermissions: 'Available Permissions',
  authorizedPermissions: 'Authorized Permissions',
  searchPermissionPlaceholder: 'Search permission name',
  selectPermissionsToAuthorize: 'Please select permissions to authorize first',
  selectPermissionsToUnauthorize: 'Please select permissions to unauthorize first',
  permissionSaveSuccess: 'Permission configuration saved successfully',
  permissionSaveFailed: 'Save failed, please try again'
}